(function () {
	"use strict";

	angular
		.module("qbePortal")
		.controller(
			"QBLoadingAnimationController",
			QBLoadingAnimationController
		);

	QBLoadingAnimationController.$inject = ["$scope", "labelService"];

	function QBLoadingAnimationController($scope, labelService) {
		var vm = this;

		$scope.$root.$on("loading-animation-start", onLoadAnimationStart);
		$scope.$root.$on("loading-animation-end", onLoadAnimationEnd);

		function onLoadAnimationStart() {
			$scope.$root.$broadcast("hide-top-banner");
			$("body").addClass("no-scroll");
			vm.animationInProgress = true;
		}

		function onLoadAnimationEnd() {
			$("body").removeClass("no-scroll");
			vm.animationInProgress = false;
		}
	}

	angular.module("qbePortal").component("qbLoadingAnimation", {
		templateUrl: "/ngviews/components/qbLoadingAnimation.html",
		controller: QBLoadingAnimationController,
		controllerAs: "vm",
		bindings: {},
	});
})();
